let schoolIdPromise = null;

export const getConfiguredSchoolId = async () => {
  if (!schoolIdPromise) {
    schoolIdPromise = fetch("/json/School_Id.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load school configuration");
        }

        return response.json();
      })
      .then((data) => {
        const configuredSchoolId = Array.isArray(data)
          ? data?.[0]?.SchoolID
          : data?.SchoolID;

        return Number(configuredSchoolId) || null;
      })
      .catch((error) => {
        console.error("School config load failed:", error);
        return null;
      });
  }

  return schoolIdPromise;
};
